import {inject, Injectable} from "@angular/core";
import {AbstractService} from "./abstract.service";
import {OverviewRepo} from "../repositories/api/overview.repo";
import {Observable} from "rxjs";
import {OverviewDto} from "../repositories/dto/overview-dto";
import {map} from "rxjs/operators";
import {UserService} from "./user.service";

@Injectable({providedIn: 'root'})
export class OverviewService extends AbstractService {

  private readonly userService: UserService = inject(UserService);
  private readonly overviewRepo: OverviewRepo = this.repoProvider.getRepo(OverviewRepo);

  public getForOrg(): Observable<OverviewDto> {
    return this.overviewRepo.getByOrg(this.getOrg())
      .pipe(map((w) => w.getFirstData()));
  }

  public getForUser(): Observable<OverviewDto> {
    return this.userService.getOverview();
  }
}
